import { z } from "zod";
import { commentTargetTypeSchema, commentTextSchema } from "../comment/models.js";

export default {
  params: z.object({
    accountId: z.string(),
    targetType: commentTargetTypeSchema,
    targetId: z.string().min(1),
    text: commentTextSchema,
  }),
  response: z.object({
    commentId: z.string(),
  }),
};
